import { WalletAddressesManage } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

import { useWithdrawRequestUsdFormStageContext } from '../FormStageContext';

const DialogWithdrawUsdWalletAddressesManage = () => {
	const { resetWalletAddressProps } = useWithdrawUsdRequestContext();

	const { navigator } = useWithdrawRequestUsdFormStageContext();

	const onAddNewAddress = useCallback(() => {
		resetWalletAddressProps();
		navigator.goTo('add-wallet-address')();
	}, [navigator, resetWalletAddressProps]);

	return (
		<WalletAddressesManage
			onAddNewAddress={onAddNewAddress}
			onEmptyWalletAddress={navigator.goTo('withdraw-funds')}
		/>
	);
};

export default DialogWithdrawUsdWalletAddressesManage;
